import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DetalleTransaccionComponent } from '../detalle-transaccion/detalle-transaccion.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { RegistrarPagosComponent } from '../registrar-pagos/registrar-pagos.component';
import { RouteService } from 'src/app/shared/services/route.service';

export interface venta {
	usuarioId: string;
	usuarioEmail: string;
	usuarioNombre: string;
	usuarioTipo: string;
	cursoId: string;
	cursoTitulo: string;
	cursoPrecioOriginal: number;
	cursoPorcentajeDescuento: number;
	cursoPrecioFinal: number;
	transaccionMoneda: string;
	transaccionTax: number;
	transaccionComisionCobro: number;
	transaccionFecha: any;
	transaccionEstatusCobro: string;
	transaccionViaCobro: string;
	transaccionId: string;
	transaccionComentario: string;
	instructorId: string;
	instructorNombre: string;
	instructorPorcentaje: number;
	instructorTotal: number;
	instructorEstatusPago: string;
	instructorFechaPago: any;
	instructorViaPago: string;
	pagoId: string;
	last4: string;
}

@Component({
	selector: 'ventas',
	templateUrl: './ventas.component.html',
	styleUrls: ['./ventas.component.css']
})

export class VentasComponent implements OnInit {

	constructor(
		public authService: AuthService,
		public afAuth: AngularFireAuth,
		private afs: AngularFirestore,
		private route: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		public dialogService: DialogService,
		public routeService: RouteService,

	) { }

	// Auxiliares para recuperacion de historico de ventas
	ventas: venta[] = []; // array de tipo venta
	id = this.route.snapshot.paramMap.get('id'); //verifica si existe un id en la ruta activa
	instructorNombre: string; //se utiliza para mostrar en cual instructor se encuentra actualmente el usuario al momento de visualizar el historico.


	// Auxiliares para registro de pago
	transaccionesMarcadas: any[] = []; // inlcuye transacciones a un arreglo de transacciones marcadas para luego ejecturar registrarPago()
	lenTransaccionesMarcadas: number; //verifica cuantas transacciones hay dentro del array para determinar si mostrar o no elementos en el HTML
	fechaPago: Date; // se obtienen del componente registrar pago
	viaPago: string; //se obtienen del componente registrar pago

	// Auxiliares para mostrar detalle de una transaccion
	transaccion: any; //objeto que se utiliza para enviar al pop de visualizacion del detalle de la transaccion
	ind: number; // Fila en la que se hace click. Se utiliza para pasar luego la data de ese al POPUP de visualizacion del detalle de la transaccion.

	// Auxiliares para transacciones de pagos
	transaccionesPagos: any[] = [];
	auxTransaccion: venta[] = [];
	pagoTotal: number = 0;

	ngOnInit() {
		this.getVentas();
	}

	getVentas() {
		this.afs.doc("global/indiceVentas").get().subscribe(snap => {
			const ventas = snap.data();
			let arr = []
			Object.keys(ventas).map(function (key) {
				arr.push(ventas[key])
				return arr;
			});
			const length = arr.length
			let arreglo = []
			for (let index = 0; index < length; index++) {
				const ventas: venta = {
					usuarioId: arr[index].usuarioId,
					usuarioEmail: arr[index].usuarioEmail,
					usuarioNombre: arr[index].usuarioNombre,
					usuarioTipo: arr[index].usuarioTipo,
					cursoId: arr[index].cursoId,
					cursoTitulo: arr[index].cursoTitulo,
					cursoPrecioOriginal: arr[index].cursoPrecioOriginal,
					cursoPorcentajeDescuento: arr[index].cursoPorcentajeDescuento,
					cursoPrecioFinal: arr[index].cursoPrecioFinal,
					transaccionMoneda: arr[index].transaccionMoneda,
					transaccionTax: arr[index].transaccionTax,
					transaccionComisionCobro: arr[index].transaccionComisionCobro,
					transaccionFecha: arr[index].transaccionFecha,
					transaccionEstatusCobro: arr[index].transaccionEstatusCobro,
					transaccionViaCobro: arr[index].transaccionViaCobro,
					transaccionComentario: arr[index].transaccionComentario,
					transaccionId: arr[index].transaccionId,
					instructorId: arr[index].instructorId,
					instructorNombre: arr[index].instructorNombre,
					instructorPorcentaje: arr[index].instructorPorcentaje,
					instructorTotal: arr[index].instructorTotal,
					instructorEstatusPago: arr[index].instructorEstatusPago,
					instructorFechaPago: arr[index].instructorFechaPago,
					instructorViaPago: arr[index].instructorViaPago,
					pagoId: arr[index].pagoId,
					last4: arr[index].last4
				}
				arreglo.push(ventas)
			}
			this.ventas = arreglo
			this.ventas.sort((a,b) => +b.transaccionFecha - +a.transaccionFecha)
			if (this.id) {
				this.ventas = this.ventas.filter(x => x.instructorId.includes(this.id))
				this.instructorNombre = this.ventas[0].instructorNombre
			}
		})
	}

	// -------------------------------------------------- Mostrar detalle de una transaccion al hacer click en ella

	openDetalleTransaccion(ind) {
		this.transaccion = this.ventas[ind]
		console.log(this.transaccion)
		this.dialog.open(DetalleTransaccionComponent, {
			data: {
				array: this.transaccion
			}
		}).afterClosed().subscribe(res => {
			if (res) {
				console.log(res)
				this.afs.collection('stripe_ventas').doc(res.transaccionId).update(res)
				if(res.transaccionEstatusCobro == 'canceled') {
					this.afs.collection('usuariosCompras').doc(res.transaccionId).delete()
				}
			}
		});
	}

	// --------------------------------------------------- Construccion del arreglo de transacciones a gaurdar al momento de registrar el pago

	checkMarcada(i, event) {
		if (event.target.checked) {
			this.incluir(i);
		} else {
			this.sacar(i);
		}
	}

	incluir(i) {
		this.transaccionesMarcadas = this.transaccionesMarcadas.concat(this.ventas[i])
		this.transaccionesMarcadas.sort((a, b) => a - b)
		this.lenTransaccionesMarcadas = this.transaccionesMarcadas.length;
		console.log(this.transaccionesMarcadas)
	}

	sacar(i) {
		const tranId = this.ventas[i].transaccionId
		const idx = this.transaccionesMarcadas.findIndex(x => x.transaccionId == tranId)
		this.transaccionesMarcadas.splice(idx, 1)
		this.transaccionesMarcadas.sort((a, b) => a - b)
		this.lenTransaccionesMarcadas = this.transaccionesMarcadas.length; //actualiza el valor de longitud del array transaccionesMarcadas
		console.log(this.transaccionesMarcadas)
	}

	openRegistrarPago() {
		this.dialog.open(RegistrarPagosComponent).afterClosed().subscribe(res => {
			if (res.viaPago) {
				this.fechaPago = res.fechaPago
				this.viaPago = res.viaPago
				this.registrarPago()
			}
		})
	}

	registrarPago() {
		let docref: AngularFirestoreDocument;
		docref = this.afs.collection('instructoresPagos').doc()
		let docId = docref.ref.id
		for (let index = 0; index < this.transaccionesMarcadas.length; index++) {
			const tran: venta = {
				usuarioId: this.transaccionesMarcadas[index].usuarioId,
				usuarioEmail: this.transaccionesMarcadas[index].usuarioEmail,
				usuarioNombre: this.transaccionesMarcadas[index].usuarioNombre,
				usuarioTipo: this.transaccionesMarcadas[index].usuarioTipo,
				cursoId: this.transaccionesMarcadas[index].cursoId,
				cursoTitulo: this.transaccionesMarcadas[index].cursoTitulo,
				cursoPrecioOriginal: this.transaccionesMarcadas[index].cursoPrecioOriginal,
				cursoPorcentajeDescuento: this.transaccionesMarcadas[index].cursoPorcentajeDescuento,
				cursoPrecioFinal: this.transaccionesMarcadas[index].cursoPrecioFinal,
				transaccionMoneda: this.transaccionesMarcadas[index].transaccionMoneda,
				transaccionTax: this.transaccionesMarcadas[index].transaccionTax,
				transaccionComisionCobro: this.transaccionesMarcadas[index].transaccionComisionCobro,
				transaccionFecha: this.transaccionesMarcadas[index].transaccionFecha,
				transaccionEstatusCobro: this.transaccionesMarcadas[index].transaccionEstatusCobro,
				transaccionViaCobro: this.transaccionesMarcadas[index].transaccionViaCobro,
				transaccionId: this.transaccionesMarcadas[index].transaccionId,
				transaccionComentario: this.transaccionesMarcadas[index].transaccionComentario,
				instructorId: this.transaccionesMarcadas[index].instructorId,
				instructorNombre: this.transaccionesMarcadas[index].instructorNombre,
				instructorPorcentaje: this.transaccionesMarcadas[index].instructorPorcentaje,
				instructorTotal: this.transaccionesMarcadas[index].instructorTotal,
				instructorEstatusPago: 'en proceso',
				instructorFechaPago: this.fechaPago,
				instructorViaPago: this.viaPago,
				pagoId: docId,
				last4: this.transaccionesMarcadas[index].last4
			}

			console.log(this.viaPago)
			this.auxTransaccion.push(tran)
			console.log(this.auxTransaccion)
			this.afs.collection('stripe_ventas').doc(tran.transaccionId).update(tran)
			this.pagoTotal= this.pagoTotal + tran.instructorTotal
		}
		docref.set({
			pagoId: docId,
			pagoTotal: this.pagoTotal,
			instructorId: this.id,
			instructorNombre: this.instructorNombre,
			transacciones: this.auxTransaccion,
			instructorFechaPago: this.fechaPago,
			instructorViaPago: this.viaPago,
			instructorEstatusPago: "en proceso",
		}, { merge: true }).then(res => {

			this.dialogService.dialogExito().afterClosed().subscribe(res => {

				this.router.navigate(['admin/detalle-pago/'+ docId]);
			})
		}).catch(error => {
			this.dialogService.dialogFracaso()
		});
	}

	doNothing(){}


}

